import { useGet, useMutationWithErrorHandling, usePost, useQueryWithErrorHandling } from '@app/sdk';
import { InstalmentPlan } from '../../models/instalmentPlan';

function useInstalmentPlanService() {
  const get = useGet(true, "ams");
  const post = usePost(true, "ams");

  async function getInstalmentPlans(accountId: string) {
    return await get<{ value: InstalmentPlan[] }>(
      `/api/proxy/ams/instalment-plan-service/accounts/${accountId}/instalment-plans`
    ).then((x) => x.value);
  }

  async function cancelInstalmentPlan(accountId: string, subledgerId: string) {
    return await post(
      `/api/proxy/ams/instalment-plan-service/accounts/${accountId}/instalment-plans/${subledgerId}/cancel`,
      {}
    );
  }

  async function reinstateInstalmentPlan(accountId: string, subledgerId: string, instalmentAmount: number | null, term: number | null) {
    let instalmentAmountWithCurrencyCode = instalmentAmount ? { value: instalmentAmount, currencyCode: 'GBP' } : null;
    return await post(
      `/api/proxy/ams/instalment-plan-service/accounts/${accountId}/instalment-plans/${subledgerId}/reinstate`,
      {
        "InstalmentAmount": instalmentAmountWithCurrencyCode,
        "Term": term
      }
    );
  }

  return {
    getInstalmentPlans,
    cancelInstalmentPlan,
    reinstateInstalmentPlan,
  };
}

export function useGetInstalmentPlans(accountId: string) {
  const { getInstalmentPlans } = useInstalmentPlanService();
  return useQueryWithErrorHandling({
    queryKey: ['instalmentPlans', accountId],
    queryFn: () => getInstalmentPlans(accountId),
    enabled: !!accountId,
  });
}

export function useCancelInstalmentPlan() {
  const { cancelInstalmentPlan } = useInstalmentPlanService();
  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, subledgerId }: { accountId: string; subledgerId: string }) =>
      cancelInstalmentPlan(accountId, subledgerId),
  });
}

export function useReinstateInstalmentPlan() {
  const { reinstateInstalmentPlan } = useInstalmentPlanService();
  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, subledgerId, instalmentAmount, term }: {
      accountId: string,
      subledgerId: string,
      instalmentAmount: number | null,
      term: number | null
    }) =>
      reinstateInstalmentPlan(accountId, subledgerId, instalmentAmount, term),
  });
}
